/**
 * Reconciliation — REPRESENTATIVE view-model (no parity backend yet). Synthetic,
 * non-client numbers only. The moat: where disagreements with the incumbent get
 * resolved, not just surfaced. Finance metrics (OPEX, EBITDA) stay excluded from
 * parity until KAL-385 is fixed — a designed state, not a blank.
 */

export const definition = {
  theirs: { title: 'Served master view · theirs', sub: 'OTIF · legacy DAX kirkstall_v1 · Apr 26', value: '90.5%', grain: 'order-line grain · calendar-month window' },
  ours: { title: 'Cortex standard · ours', sub: 'OTIF · governed standard · Apr 26', value: '94.2%', grain: 'delivery-line grain · ship-date window' },
  bridge: [
    { label: 'Theirs', v: 90.5, type: 'total' as const },
    { label: 'Grain', v: 2.1 },
    { label: 'Window', v: 1.9 },
    { label: 'Date-decode', v: -0.3 },
    { label: 'Ours', v: 94.2, type: 'total' as const },
  ],
  effects: [
    { key: 'grain effect +2.1', note: 'delivery-line vs order-line counting' },
    { key: 'window effect +1.9', note: 'ship-date vs calendar-month cut' },
    { key: 'date-decode −0.3', note: 'legacy DD/MM decode drift' },
  ],
}

export const parityCols = ['Jan', 'Feb', 'Mar', 'Apr', 'May']
export const parityRows = [
  { label: 'Revenue' },
  { label: 'GP£' },
  { label: 'OTIF' },
  { label: 'Past Due' },
  { label: 'Utilisation' },
  { label: 'NC/Batch' },
  { label: 'OPEX', excl: true },
  { label: 'EBITDA', excl: true },
]
// deterministic pass/fail (no client rows; a couple of honest misses)
const FAILS = new Set(['OTIF|Feb', 'Past Due|Mar', 'NC/Batch|May'])
export const parityPass = (row: string, col: string) => !FAILS.has(`${row}|${col}`)

export const marginBridge: { label: string; v: number; type?: 'total' }[] = [
  { label: 'Floor contrib.', v: 1620, type: 'total' },
  { label: 'Std adj.', v: -90 },
  { label: 'Overhead abs.', v: -110 },
  { label: 'Ledger GP', v: 1420, type: 'total' },
  { label: 'Sage recl.', v: -64 },
  { label: 'As-reported', v: 1356, type: 'total' },
]
